import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { catchError } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'savings-capacity-form',
    templateUrl: './savings-capacity-form.component.html',
    styleUrls: ['./savings-capacity-form.component.scss'],
    standalone: false
})
export class SavingsCapacityFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options1: FormControlOption[] = [
    { value: '1', label: 'Aucune', suffix: { title: 'A' } },
    { value: '2', label: '< 150 €', suffix: { title: 'B' } },
    { value: '3', label: '150 - 500 €', suffix: { title: 'C' } },
    { value: '4', label: '500 - 1 000 €', suffix: { title: 'D' } },
    { value: '5', label: '> 1 000 €', suffix: { title: 'E' } },
  ];
  options2: FormControlOption[] = [
    { value: '1', label: 'Aucune', suffix: { title: 'A' } },
    { value: '2', label: '< 10 000 €', suffix: { title: 'B' } },
    { value: '3', label: '10 000 - 30 000 €', suffix: { title: 'C' } },
    { value: '4', label: '30 000 - 50 000 €', suffix: { title: 'D' } },
    { value: '5', label: '> 50 000 €', suffix: { title: 'E' } },
  ];
  isSubmitting: boolean = false;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const parameters = this.subscriptionFacade.getPledge().parameters;

    this.subscriptionFacade.initForm(this, { ...parameters });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.displayErrors();

    if (this.form.valid) {
      const pledge = this.subscriptionFacade.getPledge();
      const { accountInformations } = this.extract() || {};
      pledge.accountInformations = {
        ...pledge?.accountInformations,
        ...accountInformations,
      };
      this.isSubmitting = true;
      this.subscriptionFacade
        .putPledge({ ...pledge, stepName: 'savingsCapacity' })
        .pipe(
          untilDestroyed(this),
          catchError(err => {
            this.isSubmitting = false;
            return err;
          }),
        )
        .subscribe(data => {
          this.isSubmitting = false;
          this.subscriptionFacade.nextStep();
        });
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
